import { faCalendarPlus } from '@fortawesome/pro-light-svg-icons';
import { attendanceAreaPathName, attendanceBulkPath } from '../../../areas/attendance/attendance-area-pathnames';
import { joinURL } from '../../../utilities';
import { bulkCourseEnrollmentCitizenIds } from '../../../areas/attendance/course-enrollment/bulk-course-enrollment/bulk-course-enrollment';
import { IAction } from './interfaces';

export const actions: IAction[] = [
  // {
  //   context: 'activities',
  //   id: 'BulkCourseEnrollment',
  //   displayName: 'Opret fremmødeforløb',
  //   action: async (_selectedIds, _selectedRootIds, _isFeatureEnabled, _replaceUrl, selectedEntities) => {
  //     const popup = window.open(joinURL('/', attendanceAreaPathName, attendanceBulkPath));
  //     const key = bulkCourseEnrollmentCitizenIds;
  //     function isReady(event: MessageEvent) {
  //       if (event.data.topic === `${key}_Ready` && popup) {
  //         popup.postMessage({ data: selectedEntities, topic: `${key}_Topic` });
  //         window.removeEventListener('message', isReady);
  //       }
  //     }
  //     window.addEventListener('message', isReady, false);
  //   },
  //   icon: faCalendarPlus,
  //   isVisible: (selectedItemsCount, isFeatureEnabled) => isFeatureEnabled('EnableAttendanceMassActionInFrontend') && selectedItemsCount > 0,
  //   isDisabled: (selectedItemsCount, _rowCount, _isLoading, selectedItems) => {
  //     if (selectedItemsCount > 20) {
  //       return 'Antallet af valgte elementer må ikke overstige 20';
  //     }
  //     const ids = selectedItems.map(item => item.rootEntityId);
  //     const hasDuplicates = new Set(ids).size !== ids.length;
  //     if (hasDuplicates) {
  //       return 'Den samme borger er valgt flere gange. Fjern dubletter for at oprette et fremmøde forløb.';
  //     }
  //     return '';
  //   },
  // },
];
